import styled from '@emotion/styled';
import { Link } from '@reach/router';
import { createPortal } from 'react-dom';
import colors from '../../../lib/colors';
import { Trans } from 'react-i18next';
import { useContext } from 'react';
import { ScenesProgressContext } from '../ScenesProgressProvider';

export const FLOATING_PROFILE_POSITION_ID = 'floating-profile-position';

const FloatingProfilePosition = () => {
  const { tournamentActive } = useContext(ScenesProgressContext);
  const targetElement = document.getElementById(FLOATING_PROFILE_POSITION_ID);
  const renderPosition = () => {
    return tournamentActive ? (
      <FloatingProfilePositionLink to="/ranking">
        <ProfilePositionWrapper>
          <Trans i18nKey="lobby.profile.position" />
        </ProfilePositionWrapper>
      </FloatingProfilePositionLink>
    ) : null;
  };

  return targetElement ? createPortal(renderPosition(), targetElement) : null;
};

export default FloatingProfilePosition;

const FloatingProfilePositionLink = styled(Link)`
  text-decoration: none;
`;

const ProfilePositionWrapper = styled('div')`
  color: ${colors.lobbyText};
  margin-bottom: 0.8em;
`;
